import { call, options, params } from './helpers';

// Core CRUD
export const getWorkOrders = (payload) =>
	call(`/beta/work-orders${params(payload)}`);

export const getWorkOrderStats = (payload) =>
	call(`/beta/work-orders/stats${params(payload)}`);

export const getWorkOrdersCalendar = (payload) =>
	call(`/beta/work-orders/calendar${params(payload)}`);

export const getWorkOrder = ({ id }) => call(`/beta/work-orders/${id}`);

export const getWorkOrderStatistics = ({ id }) =>
	call(`/beta/work-orders/${id}/statistics`);

export const createWorkOrder = (payload) =>
	call(`/beta/work-orders`, options(payload, 'POST'));

export const updateWorkOrder = ({ id, ...payload }) =>
	call(`/beta/work-orders/${id}`, options(payload, 'PUT'));

export const updateWorkOrderStatus = ({ id, status, comment }) =>
	call(`/beta/work-orders/${id}/status`, options({ status, comment }, 'PUT'));

export const deleteWorkOrder = ({ id }) =>
	call(`/beta/work-orders/${id}`, options(null, 'DELETE'));

// Comments
export const addWorkOrderComment = ({ id, comment }) =>
	call(`/beta/work-orders/${id}/comment`, options({ comment }, 'POST'));

// Contacts/Vendors
export const addWorkOrderContact = ({ id, contactId, role, isPrimary }) =>
	call(`/beta/work-orders/${id}/contacts`, options({ contactId, role, isPrimary }, 'POST'));

export const removeWorkOrderContact = ({ id, contactId }) =>
	call(`/beta/work-orders/${id}/contacts/${contactId}`, options(null, 'DELETE'));

// Assets
export const addWorkOrderAsset = ({ id, assetId, notes, contractId }) =>
	call(`/beta/work-orders/${id}/assets`, options({ assetId, notes, contractId }, 'POST'));

export const removeWorkOrderAsset = ({ id, assetId }) =>
	call(`/beta/work-orders/${id}/assets/${assetId}`, options(null, 'DELETE'));

// Documents
export const addWorkOrderDocuments = ({ id, files, documentIds }) =>
	call(
		`/beta/work-orders/${id}/documents`,
		options({ files, documentIds, information: {}, bucket: 'work-orders' }, 'POST')
	);

export const removeWorkOrderDocument = ({ id, documentId }) =>
	call(`/beta/work-orders/${id}/documents/${documentId}`, options(null, 'DELETE'));

// Checklist
export const getWorkOrderChecklist = ({ id }) =>
	call(`/beta/work-orders/${id}/checklist`);

export const createWorkOrderChecklistItem = ({ id, ...payload }) =>
	call(`/beta/work-orders/${id}/checklist`, options(payload, 'POST'));

export const updateWorkOrderChecklistItem = ({ id, checklistItemId, ...payload }) =>
	call(`/beta/work-orders/${id}/checklist/${checklistItemId}`, options(payload, 'PUT'));

export const reorderWorkOrderChecklistItems = ({ id, items }) =>
	call(`/beta/work-orders/${id}/checklist/reorder`, options({ items }, 'PUT'));

export const deleteWorkOrderChecklistItem = ({ id, checklistItemId }) =>
	call(`/beta/work-orders/${id}/checklist/${checklistItemId}`, options(null, 'DELETE'));

export const addWorkOrderSopTasks = ({ id, sopId }) =>
	call(`/beta/work-orders/${id}/checklist/sop`, options({ sopId }, 'POST'));

// Service Schedules
export const getServiceSchedules = (payload) =>
	call(`/beta/service-schedules${params(payload)}`);

export const getServiceSchedule = ({ id }) =>
	call(`/beta/service-schedules/${id}`);

export const createServiceSchedule = (payload) =>
	call(`/beta/service-schedules`, options(payload, 'POST'));

export const updateServiceSchedule = ({ id, ...payload }) =>
	call(`/beta/service-schedules/${id}`, options(payload, 'PUT'));

export const deleteServiceSchedule = ({ id }) =>
	call(`/beta/service-schedules/${id}`, options(null, 'DELETE'));

export const generateDueWorkOrders = () =>
	call(`/beta/service-schedules/generate`, options(null, 'POST'));
